// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:780px){[data-v-a6be5780] .v-btn{margin-top:10px!important;padding-top:10px!important}[data-v-a6be5780] .v-text-field{width:100%!important;-webkit-box-flex:1;-ms-flex:1 1 100%;flex:1 1 100%;margin-bottom:10px!important}}", ""]);
// Exports
module.exports = exports;
